import React, {Component} from 'react';

import AnimatedWrapper from '../../core/animated-wrapper';
import NewsletterBox from '../newsletter-box';
import LoadingIndication from '../../common/loading-indicator';
import SiteSubscription from '../../common/site-subscription';

import universalTagNamesService from '../../../services/universal-tag-names';
import newslettersService from '../../../services/newsletters';
import shareService from '../../../services/share';

import './newsletter-subscription.css';

class NewsletterSubscription extends Component {
  constructor(props) {
    super(props);

    const tag = props.match.params.tag;

    let twitterTags;
    let publicName;

    if (tag === 'angular') {
      publicName = 'Angular TypeScript',
      twitterTags = ['angular', 'typescript', 'javascript'];
    }
    else {
      twitterTags = universalTagNamesService.getTwitterTagsByTagForNewsletter(tag);
      publicName = universalTagNamesService.getPublicTagName(tag);
    }

    shareService.setupPage({ 
      title: `${publicName} Trends Subscription`,
      isTitlePrefixOn: false,
      tags: twitterTags
    });

    this.state = {
      newsletters: [],
      isLoading: true,
      isError: false,
      publicName,
      tag,
    };
  }

  componentDidMount() {
    newslettersService.getNewsletters(this.state.tag, 1)
      .then(({ newsletters }) => {
        this.setState({
          isLoading: false,
          newsletters: newsletters.slice(0, 3).map((newsletter, i) => {
            return {
              ...newsletter,
              buffText: i === 0 ? 'Latest Newsletter' : '',
            };
          }),
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }  

  render() {
    const { 
      newsletters,
      publicName,
      isLoading,
      tag,
    } = this.state;

    return (
      <div className='full-page newsletter-subscription-page'>
        <div className='sections-container'>
          <section className='dark section-container newsletter-subscription-header'>
            <div className='newsletter-type-badge'>
              <img src={ `/images/newsletters/badges/${ tag }.png` } title={ publicName } />
            </div>

            <h3>{ publicName } Trends</h3>

            {/*<p>The free, weekly { publicName } Trends of the <span>best content</span> on the web</p>*/}
            {/*<p>We <span>crawl</span> the web for you and then <span>hand-pick</span> the best content</p>
            <p>Delivered directly to your inbox <span>once a week</span></p>
            <p>Curated with <span className='emoji'>❤️</span> by DorMoshe.io</p>*/}
            <ul>
              <li>Our algorithms <span>crawl</span> the web</li>
              <li><span>Hand-picked</span> the <span>best</span> content</li>
              <li>Delivered <span>once a week</span></li>
              <li>The only way to get <span>early access</span></li>
            </ul>

            <span className='curated'>Curated with <span className='emoji'>❤️</span> by DorMoshe.io</span>

            <SiteSubscription isInline={ true } source='Newsletter-Subscription' mailingListKey={ tag } isBottomTextShown={ false } /> 
          </section>

          <section className='section-container'>
            <div className='newsletter-bubbles'>
              <div className='bubble-box'><span>
                <span>~10k</span> resources crawled per week
              </span></div>

              <div className='bubble-box'><span>
                It's <span>free</span>
              </span></div>

              <div className='bubble-box'><span>
                Best 6 articles <span>hand-picked</span>
              </span></div>

              <div className='bubble-box'><span>
                No spam
              </span></div>

              <div className='bubble-box'><span>
                <span>Easy</span> to unsubscribe</span>
              </div>

              <div className='bubble-box'><span>
                We keep your email address <span>private</span>
              </span></div>
            </div>
          </section>

          <section className='dark section-container newsletters-container'>
            <h4>Dig into the latest issues</h4>

            <LatestNewsletters { ...this.state } />

            <SiteSubscription isInline={ true } source='Newsletter-Subscription' mailingListKey={ tag } isBottomTextShown={ false } />             
          </section>

          <div className='fake-background-remover'></div>         
        </div>
      </div>
    );
  }
}

function LatestNewsletters({ isLoading, newsletters, tag, }) {
  if (isLoading) {
    return (
      <LoadingIndication />
    );
  }
  
  return <div className='newsletters'>
    {
      newsletters.map((newsletter) => 
        <div key={ newsletter._id } className='little-grow-animation'>
          <NewsletterBox tag={ tag } { ...newsletter } />
        </div>
      )
    }
  </div>
}

const AnimatedHome = AnimatedWrapper(NewsletterSubscription);
export default AnimatedHome;